import {HttpClient} from "../httpClient/HttpClient";

export function uploadFile(
    file,
    progress,
    buffer,
    hideUploadingLoading,
    url = "",
    requestQuery = {}
) {

    hideUploadingLoading(false)

    const options = {
        onUploadProgress: (progressEvent) => {
            const {loaded, total} = progressEvent;
            let percent = Math.floor((loaded * 100) / total)
            progress(percent)
            if (percent + 5 <= 100) {
                buffer(percent + 5)
            } else
                buffer(100)

            if (percent === 100) {
                hideUploadingLoading(true)
            }
        }
    }

    let data = new FormData()
    data.append('file', file)

    const httpClient = new HttpClient(options,"multipart/form-data")

    return new Promise((resolve, reject) => {
        httpClient
            .post(
                url,
                data,
                {
                    "Content-Type": "multipart/form-data",
                },
                requestQuery
            ).then(resolve).catch(reason => {
            hideUploadingLoading(true)
            reject(reason)
        })
    })

}